const steps = [
  {
    number: "01",
    title: "Consultation & Project Planning",
    desc: "We meet to understand your vision, goals, and budget — laying the foundation for a successful project.",
  },
  {
    number: "02",
    title: "Design & Scope Development",
    desc: "Our team develops a detailed design and project scope that aligns with your needs and local regulations.",
  },
  {
    number: "03",
    title: "Material Selection & Scheduling",
    desc: "We source premium materials and create a clear schedule so you know exactly what to expect and when.",
  },
  {
    number: "04",
    title: "Construction & Execution",
    desc: "Our skilled craftsmen execute the build with precision, maintaining open communication throughout.",
  },
  {
    number: "05",
    title: "Final Walkthrough & Completion",
    desc: "We conduct a thorough final inspection with you to ensure every detail meets our quality standards.",
  },
];

interface ProcessSectionProps {
  subtitle?: string;
}

export default function ProcessSection({ subtitle }: ProcessSectionProps) {
  return (
    <section className="py-24 bg-brand-warm">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="w-full h-[520px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/f63da62ac0e8b72da821dcdc3e26ae1d.jpg"
                alt="Westec Builders construction process team at work on residential project"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-brand-amber text-white rounded-2xl p-6 shadow-none">
              <p className="font-heading font-bold text-4xl">15+</p>
              <p className="text-sm font-body mt-1 text-white/90">Years of Excellence</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <p className="text-xs font-body text-brand-amber uppercase tracking-widest font-semibold mb-3">
              (Our Process)
            </p>
            <h2 className="font-heading font-bold text-4xl lg:text-5xl text-brand-dark mb-4 leading-tight">
              Our Proven<br />Construction Process
            </h2>
            {subtitle && (
              <p className="text-brand-charcoal font-body text-base leading-relaxed mb-8">{subtitle}</p>
            )}
            <div className="flex flex-col gap-6 mt-8">
              {steps.map((step) => (
                <div key={step.number} className="flex gap-4 items-start">
                  <div className="w-10 h-10 flex items-center justify-center bg-brand-dark text-white rounded-lg text-xs font-heading font-bold flex-shrink-0">
                    {step.number}
                  </div>
                  <div>
                    <p className="font-body font-semibold text-brand-dark text-sm">{step.title}</p>
                    <p className="font-body text-brand-charcoal text-sm mt-1 leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
